import { render, staticRenderFns } from "./intensive.vue?vue&type=template&id=0520e3c2"
import script from "./intensive.vue?vue&type=script&lang=js"
export * from "./intensive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports